import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button
} from '@mui/material';
import {
  Home as ResidentialIcon,
  Business as CommercialIcon,
  Construction as ConstructionIcon
} from '@mui/icons-material';

const QuoteTypeSelector = ({ onSelect }) => {
  const quoteTypes = [
    {
      type: 'residential',
      title: 'Residential Quote',
      description: 'For homeowners and residential properties',
      icon: <ResidentialIcon sx={{ fontSize: 48, color: '#4caf50' }} />,
      color: '#4caf50',
      features: ['Lawn Care', 'Gardening', 'Spring/Fall Cleanup', 'Snow Removal', 'Turf Programs']
    },
    {
      type: 'commercial',
      title: 'Commercial Quote',
      description: 'For businesses and commercial properties',
      icon: <CommercialIcon sx={{ fontSize: 48, color: '#2196f3' }} />,
      color: '#2196f3',
      features: ['Property Maintenance', 'Landscaping', 'Snow Management', 'Parking Lot Services']
    },
    {
      type: 'construction',
      title: 'Construction Quote',
      description: 'For construction and custom projects',
      icon: <ConstructionIcon sx={{ fontSize: 48, color: '#ff9800' }} />,
      color: '#ff9800',
      features: ['Custom Line Items', 'Project-Based Pricing', 'Flexible Services']
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" align="center" sx={{ mb: 1, color: '#000062', fontWeight: 'bold' }}>
        Create New Quote
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 4, color: '#666', fontWeight: 'normal' }}>
        Choose the type of quote you'd like to create
      </Typography>
      
      <Grid container spacing={3} justifyContent="center">
        {quoteTypes.map((quoteType) => (
          <Grid size={{ xs: 12, md: 4 }} key={quoteType.type}>
            <Card 
              sx={{ 
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '2px solid transparent',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4,
                  borderColor: quoteType.color
                }
              }}
              onClick={() => onSelect(quoteType.type)}
            >
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ mb: 2 }}>
                  {quoteType.icon}
                </Box>
                
                <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: quoteType.color }}>
                  {quoteType.title}
                </Typography>
                
                <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
                  {quoteType.description}
                </Typography>
                
                <Box sx={{ textAlign: 'left', mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                    Includes:
                  </Typography>
                  {quoteType.features.map((feature, index) => (
                    <Typography key={index} variant="body2" sx={{ mb: 0.5, color: '#666' }}>
                      • {feature}
                    </Typography>
                  ))}
                </Box>
                
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: quoteType.color,
                    '&:hover': {
                      backgroundColor: quoteType.color,
                      filter: 'brightness(0.9)'
                    }
                  }}
                >
                  Create {quoteType.title}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuoteTypeSelector;
